import React from 'react'
import HighlightedCardSection from '../../../react4xp/components/HighlightedCardSection'

function HighlightedCardPart({ image, title, text, color }) {
	return (
		<HighlightedCardSection
			image={image?.link && {
				src: image.link,
				alt: image.alt
			}}
			title={title}
			text={text}
			cardBgColor={color}
		/>
	)
}

export default (props) => <HighlightedCardPart {...props} />
